import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ element, refusedRoles = [], ...rest }) => {
  //const { isAuthenticated, user } = useSelector((state) => state.auth);

  // Validar roles restringidos (refusedRoles)
  /*if (!isAuthenticated || (refusedRoles.length > 0 && user.roles.some((role) => refusedRoles.includes(role)))) {
    return <Navigate to="/login" replace />;
  }*/

  // Si pasa todas las validaciones, renderiza el componente
  return element;
};

export default ProtectedRoute;
